module.exports = "/assets/data/c4bc745258eb851bc28d80f71634598c-EX32.data.json";